import { useEffect, useState } from "react";

const MOBILE_USER_AGENT_REGEX = /android|webos|iphone|ipad|tablet/i;
const DESKTOP_OS_REGEX =
  /cros|ubuntu|debian|fedora|opensuse|arch|mint|manjaro|windows|macos|mac os x/i;
const IPAD_REGEX = /ipad/i;
const TABLET_REGEX = /tablet/i;
const X11_REGEX = /x11/i;
const ANDROID_REGEX = /android/i;

const isIpadOrTablet = () => {
  const isIpad = IPAD_REGEX.test(navigator.userAgent);
  const isTablet = TABLET_REGEX.test(navigator.userAgent);
  return isIpad || isTablet;
};

const isMobileUserAgent = (userAgent: string) => {
  if (MOBILE_USER_AGENT_REGEX.test(userAgent)) {
    return true;
  }

  if (X11_REGEX.test(userAgent)) {
    if (DESKTOP_OS_REGEX.test(userAgent)) {
      return false;
    }

    if (ANDROID_REGEX.test(userAgent)) {
      return true;
    }

    return false;
  }
};

export const isMobileDevice = () => {
  const hasTouchSupport =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUA = isMobileUserAgent(userAgent);
  return hasTouchSupport && (isMobileUA || isIpadOrTablet());
};

export const useIsMobileDevice = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(isMobileDevice());
    };

    checkDevice();

    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  return isMobile;
};